"use client";

import { cn } from "@/lib/utils";
import { usePathname } from "next/navigation";

/**
 * The console sidebar
 */

type SidebarMenuItem = {
  label: string;
  href: string;
};

const sidebar_menu_items = [
  {
    label: "PLAYGROUND",
    links: [
      {
        label: "Playground",
        href: "/c/playground",
      },
    ],
  },
  {
    label: "CLOUD",
    links: [
      {
        label: "API Keys",
        href: "/c/cloud/api-keys",
      },
      {
        label: "Usage",
        href: "/c/cloud/usage",
      },
      {
          label: "Billing",
          href: "/c/cloud/billing",
      },
    ],
  },
];

function CSidebarMenuItem({
  label,
  href,
  selected,
}: {
  label: string;
  selected: boolean;
  href: string;
}) {
  return (
    <a
      href={href}
      className={cn(
        "flex flex-row gap-2 items-center pl-4 pr-3 py-2.5 text-sm no-underline rounded border-none text-foreground hover:bg-muted",
        selected && "font-semibold"
      )}
    >
      {label}
    </a>
  );
}

function CSidebarGroup({
  label,
  items,
  top,
}: {
  label: string;
  items: SidebarMenuItem[];
  top: boolean;
}) {
  const curPath = usePathname();

  return (
    <div className="flex flex-col gap-2">
      <span
        className={cn(
          "text-xs font-semibold text-muted-foreground uppercase pl-2",
          top ? "" : "mt-6"
        )}
      >
        {label}
      </span>
      <div className="flex divide-x flex-col overflow-hidden">
        {items.map((link) => (
          <CSidebarMenuItem
            key={link.href}
            href={link.href}
            label={link.label}
            selected={curPath === link.href}
          />
        ))}
      </div>
    </div>
  );
}

export default function CSidebarContent() {
  return (
    <div className="container flex flex-col gap-6 pb-10 md:flex-row">
      <div className="flex w-full flex-col gap-2">
        {sidebar_menu_items.map((item, index) => (
          <CSidebarGroup
            key={item.label}
            label={item.label}
            items={item.links}
            top={index === 0}
          />
        ))}
      </div>
    </div>
  );
}
